/**
 * =============================================================================
 * IDS CRM Web - Application Entry Point
 * =============================================================================
 *
 * PURPOSE:
 * Main entry point for the React application. Renders the root App component
 * into the DOM and registers the service worker for PWA functionality.
 *
 * PWA FEATURES:
 * - Service worker for offline capability
 * - Add to home screen on iPad Safari
 * - Background sync for offline data submission
 *
 * =============================================================================
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/uiHardening.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Create React root and render application.
 * StrictMode enables additional development checks.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * Report web vitals for performance monitoring.
 * In production, send to analytics endpoint.
 *
 * @see https://bit.ly/CRA-vitals
 */
reportWebVitals();
